import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import {
  InputCustom,
  SelectCustom,
  Loading,
  HttpError,
  InputMaskCustom
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModalWithLabel } from "../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
class UnidadesModalForm extends Component {
  constructor() {
    super()
    this.onChangeCodigo = this.onChangeCodigo.bind(this)
    this.onChangeNome = this.onChangeNome.bind(this)
    this.onChangeTipoAdmin = this.onChangeTipoAdmin.bind(this)
    this.onChangeEmail = this.onChangeEmail.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.onChangeCNPJ = this.onChangeCNPJ.bind(this)
    this.onChangeEndereco = this.onChangeEndereco.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showForm: true,
      tipoAdmin: "",
      nome: "",
      codigo: "",
      email: "",
      endereco: "",
      cnpj: ""
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Unidade orçamentária atualizada com sucesso"
    } else {
      message = "Unidade orçamentária cadastrada com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentDidMount() {
    if (this.props.isEditing) {
      this.setState({ showForm: false })
      this.getObject()
    }
  }
  getObject() {
    ApiHelper.getUnidadeOrcamentaria(
      this.props.match.params.id,
      (unidade, error) => {
        if (unidade) {
          this.fillFields(unidade)
          window.scrollTo(0, 0)
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  fillFields(fields) {
    var currentFields = {
      tipoAdmin: fields.tipo_admin,
      nome: fields.uni_orc,
      codigo: fields.cod_uni_orc,
      nomeLabel: fields.uni_orc,
      email: fields.email,
      endereco: fields.endereco,
      cnpj: fields.cnpj,
      showForm: true
    }
    this.setState(currentFields)
  }
  onChangeCodigo(event) {
    var newValue = event.target.value
    this.setState({ cod_uni_orcError: "", codigo: newValue })
  }
  onChangeNome(event) {
    var newValue = event.target.value
    this.setState({ uni_orcError: "", nome: newValue })
  }
  onChangeTipoAdmin(event) {
    var newValue = event.target.value
    this.setState({ tipo_adminError: "", tipoAdmin: newValue })
  }
  onChangeEmail(event) {
    var newValue = event.target.value
    this.setState({ emailError: "", email: newValue })
  }
  onChangeCNPJ(event) {
    var newValue = event.target.value
    this.setState({ cnpjError: "", cnpj: newValue })
  }
  onChangeEndereco(event) {
    var newValue = event.target.value
    this.setState({ enderecoError: "", endereco: newValue })
  }
  sendForm(event) {
    event.preventDefault()
    var parameters = {
      uni_orc: this.state.nome,
      cod_uni_orc: this.state.codigo,
      tipo_admin: this.state.tipoAdmin,
      email: this.state.email,
      endereco: this.state.endereco,
      cnpj: Util.unmaskField(this.state.cnpj)
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateUnidade(
        parameters,
        this.props.match.params.id,
        errors => {
          this.toggleLoadModal()
          if (errors) {
            this.showErrorMessage()
            this.handleErrors(errors)
          } else {
            this.showSucessMessage()
            Util.sleep(3000).then(() => {
              this.props.callBackUnidades()
            })
          }
        }
      )
    } else {
      ApiHelper.createNewUnidade(parameters, errors => {
        this.toggleLoadModal()
        if (errors) {
          this.showErrorMessage()
          this.handleErrors(errors)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackUnidades()
          })
        }
      })
    }
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  render() {
    var tipos = [
      { value: null, label: "" },
      { value: "D", label: "Direta" },
      { value: "I", label: "Indireta" }
    ]
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    return (
      <div>
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        {this.state.showForm === false && <Loading />}
        {this.state.showForm === true && (
          <div className="card card-plain">
            <ToastContainer
              ref={input => {
                this.container = input
              }}
              toastMessageFactory={this.toastFactory}
              className="toast-top-right"
              preventDuplicates={true}
            />
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">Criar unidade orçamentária</h4>
              <p className="category">Nova unidade orçamentária</p>
            </div>
            <div className="card-content">
              <form>
                <div className="row">
                  <InputCustom
                    error={this.state.cod_uni_orcError}
                    sizeClass="col-md-4"
                    label="Código da unidade orçamentária"
                    type="number"
                    onChange={this.onChangeCodigo}
                    value={this.state.codigo}
                  />
                  <InputCustom
                    error={this.state.uni_orcError}
                    sizeClass="col-md-4"
                    label="Nome da unidade orçamentária"
                    type="text"
                    onChange={this.onChangeNome}
                    value={this.state.nome}
                  />
                  <SelectCustom
                    error={this.state.tipo_adminError}
                    sizeClass="col-md-4"
                    options={tipos}
                    label="Tipo de administração"
                    name="tipo_admin"
                    onChange={this.onChangeTipoAdmin}
                    value={this.state.tipoAdmin}
                  />
                </div>
                <div className="row">
                  <InputCustom
                    error={this.state.enderecoError}
                    sizeClass="col-md-4"
                    label="Endereco"
                    type="text"
                    onChange={this.onChangeEndereco}
                    value={this.state.endereco}
                  />
                  <InputMaskCustom
                    error={this.state.cnpjError}
                    sizeClass="col-md-2"
                    label="CNPJ"
                    type="text"
                    mask="99.999.999/9999-99"
                    onChange={this.onChangeCNPJ}
                    value={this.state.cnpj}
                  />
                </div>
                <div className="row">
                  <InputCustom
                    error={this.state.emailError}
                    sizeClass="col-md-4"
                    label="Email (Opcional, todas as notificações serão enviadas a este email)"
                    type="text"
                    onChange={this.onChangeEmail}
                    value={this.state.email}
                  />
                </div>

                <button
                  onClick={this.sendForm}
                  type="submit"
                  className="btn btn-primary pull-right"
                  data-background-color="as-blue"
                >
                  {this.props.isEditing ? "Salvar" : "Criar"}
                </button>
                <div className="clearfix" />
              </form>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default withRouter(UnidadesModalForm)



// WEBPACK FOOTER //
// ./src/views/modais/UnidadesForm.js